import React, { useState, useEffect } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { useDispatch, useSelector } from "react-redux";
import { SetAuthMatrixFurtherDetailsAction, GetCompanyAccountAuthorizationAction } from "../../../redux/actions/companyAction";

function AuthMatrix({ companyId }) {

    const [loading, setloading] = useState([]);
    const [selectedRow, setselectedRow] = useState([]);
    const dispatch = useDispatch();

    const getCompanyAccountAuthorizationMatrix = async () => {
        await dispatch(GetCompanyAccountAuthorizationAction("zbizgateway/nonFin/getCompanyAuthMatrix/" + companyId));
    };

    useEffect(() => {
        getCompanyAccountAuthorizationMatrix();
        setloading(false);
    }, []);

    const AuthorizationMatrixData = useSelector((state) => state?.companySlice?.companyAuthMatrixDetails);

    const onRowSelect = (event) => {
        dispatch(SetAuthMatrixFurtherDetailsAction(event?.data));
        localStorage.setItem("authMatrixHeadId", event?.data?.authMatrixHeadId)
    };

    useEffect(() => {
        dispatch(SetAuthMatrixFurtherDetailsAction(""));
    }, []);

    return (
        <div>
            <div className="card p-datatable-sm">
                <DataTable
                    // header="Company Account Authorization Matrix"
                    selection={selectedRow}
                    onSelectionChange={(e) => setselectedRow(e.value)}
                    selectionMode="single"
                    dataKey="authMatrixHeadId"
                    onRowSelect={onRowSelect}
                    loading={loading}
                    paginator
                    rows={5}
                    value={AuthorizationMatrixData}
                    emptyMessage="No data found."
                >
                    <Column filter field="tblProduct.productName" header="Product Name" />
                    {/* <Column filter field="fromAmount" header="From Amount" /> */}
                    <Column filter field="toAmount" header="Transaction Limit" />
                </DataTable>
            </div>
        </div>
    );
}

export default AuthMatrix;
